/**
 * Public "Take me home" directions.
 *
 * Destination only — no origin — so Maps uses the phone's current location.
 * The query is the USPS postal address (FPL bill and the property listing),
 * without the unit. "Babcock Ranch" is not the USPS city, and a unit number
 * sends the geocoder to the wrong place.
 *
 * This string is intentionally in the client bundle. The CI home-address
 * guard allowlists this exact destination and still fails on any other
 * occurrence of the house number.
 */
export const TAKE_ME_HOME_ADDRESS = '43030 Greenway Blvd, Punta Gorda, FL 33982';

export function takeMeHomeDirectionsUrl(): string {
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(TAKE_ME_HOME_ADDRESS)}`;
}
